export const TRANSITION_PROPS = {
    default: {
        scale: 1
    },
    active: {
        scale: 0.9
    }
};
